module.exports = __webpack_public_path__ + "img/control_manage_img_min.42093024.png";